import { types } from "../action-types";

const initialState = {
  loading: false,
  interviews: [],
  error: false,
};

const getAllInterviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALLINTERVIEWS_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_ALLINTERVIEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        interviews: action.payload,
        error: false,
      };
    case types.GET_ALLINTERVIEWS_FAILURE:
      return {
        ...state,
        loading: false,
        interviews: [],
        error: true,
      };
    default:
      return state;
  }
};

export default getAllInterviewsReducer;
